import { Box, Skeleton } from "@mui/material";

export const SkeletonRowsOverlay = ({ columnsCount = 5, rowsCount = 10 }) => (
    <Box sx={{ py: 1 }}>
        {Array.from({ length: rowsCount }).map((_, rowIdx) => (
            <Box
                key={rowIdx}
                sx={{
                    display: "grid",
                    gridTemplateColumns: `repeat(${columnsCount}, 1fr)`,
                    gap: 1.5,
                    mb: 1.8,
                }}
            >
                {Array.from({ length: columnsCount }).map((_, colIdx) => (
                    <Skeleton
                        key={colIdx}
                        variant="rectangular"
                        height={38}
                        sx={{ borderRadius: 1 }}
                    />
                ))}
            </Box>
        ))}
    </Box>
);
